





import { defineComponent } from '@vue/composition-api';

// 引入组件
import SeparateFile from '@/renderer/components/SeparateFile/components/index.vue';
export default defineComponent({
  components: {
    SeparateFile,
  },
  setup(props, context) {
    return {};
  },
});
